import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

export interface RemoveTeamMemberDialogData {
  userName?: string;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
}

const DEFAULTS = {
  title: 'Remove Team Member?',
  message: 'Are you sure you would like to remove this user? You can always invite them back later.',
  confirmText: 'Remove',
  cancelText: 'Cancel',
} as const;

@Component({
  selector: 'app-remove-team-member-dialog',
  templateUrl: './remove-team-member-dialog.component.html',
  styleUrls: ['./remove-team-member-dialog.component.scss'],
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RemoveTeamMemberDialogComponent {
  dialogRef = inject<MatDialogRef<RemoveTeamMemberDialogComponent>>(MatDialogRef);
  data = inject<RemoveTeamMemberDialogData>(MAT_DIALOG_DATA);

  readonly title = computed(() => this.data.title ?? DEFAULTS.title);
  readonly message = computed(() => this.data.message ?? DEFAULTS.message);
  readonly confirmText = computed(() => this.data.confirmText ?? DEFAULTS.confirmText);
  readonly cancelText = computed(() => this.data.cancelText ?? DEFAULTS.cancelText);

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onRemove(): void {
    this.dialogRef.close(true);
  }
}
